import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { searchStickers } from "api/stickerService";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import Breadcrumb from "components/Breadcrumb";
import SearchStickerManager from "./data/SearchStickerManager";
import StickerManagerTable from "./data/StickerManagerTable";

function StickerTables({ workingPage, childPage }) {
  const [totalElements, setTotalElements] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [stickerData, setStickerData] = useState([]);
  const [searchData, setSearchData] = useState({
    code: "",
    name: "",
    status: -1,
    page: curPage,
    size: rowsCount,
  });

  useEffect(() => {
    setSearchData((prev) => ({ ...prev, page: curPage, size: rowsCount }));
  }, [curPage, rowsCount]);

  useEffect(() => {
    searchStickers(searchData).then((data) => {
      if (data?.object) {
        setStickerData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  }, []);

  const clickToSearch = () => {
    setCurPage(0);
    searchStickers({ ...searchData, page: 0 }).then((data) => {
      if (data?.object) {
        setStickerData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  };

  const refreshDataAfterChange = () => {
    searchStickers(searchData).then((data) => {
      if (data?.object) {
        setStickerData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  };

  const renderData = useMemo(
    () => (
      <StickerManagerTable
        data={stickerData}
        totalElements={totalElements}
        curPage={curPage}
        setCurPage={setCurPage}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        refreshDataAfterChange={refreshDataAfterChange}
      />
    ),
    [curPage, rowsCount, totalElements, stickerData]
  );

  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              <Breadcrumb
                items={[
                  {
                    label: "Quản lý Sticker",
                  },
                ]}
              />
              <SearchStickerManager
                clickSearch={clickToSearch}
                setSearchData={setSearchData}
                searchData={searchData}
                refreshDataAfterChange={refreshDataAfterChange}
              />
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              {renderData}
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
          </Grid>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

StickerTables.defaultProps = {
  workingPage: "",
  childPage: [],
};

StickerTables.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default StickerTables;
